import { Injectable } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/compat/storage';

@Injectable({
  providedIn: 'root'
})
export class ImageService {

  constructor(private afStorage: AngularFireStorage) { }

  uploadLogo(imageURL: string, eventId: string) {
    const storageRef = this.afStorage.ref(`/logos/${eventId}`);
    return storageRef.putString(imageURL, 'data_url', {contentType: 'image/png'});
  }

  uploadCoupon(imageURL: string, eventId: string) {
    const storageRef = this.afStorage.ref(`/coupons/${eventId}`);
    return storageRef.putString(imageURL, 'data_url', {contentType: 'image/png'});
  }

  uploadBanner(imageURL: string, eventId: string) {
    const storageRef = this.afStorage.ref(`/banners/${eventId}`);
    return storageRef.putString(imageURL, 'data_url', {contentType: 'image/png'});
  }

  uploadPricelistPhoto(imageURL: string, eventId: string, pricelistItemId: string) {
    const storageRef = this.afStorage.ref(`/pricelist/${eventId}/${pricelistItemId}`);
    return storageRef.putString(imageURL, 'data_url', {contentType: 'image/png'});
  }
}
